import { Title } from "./styles";

const PageTitle = ({title}) => {
    return (
        <Title>{title}</Title>
    )
}

export default PageTitle;